import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  filters: { range: "all", from: null, to: null },
};

const captureDashboardSlice = createSlice({
  name: "captureDashboard",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const { setFilters } = captureDashboardSlice.actions;

export default captureDashboardSlice.reducer;
